<template>
  <div :class="['form-select', '--is-select']">
    <select
      :id="id || this.uniqueId()"
      :name="name"
      :class="['form-select__control', '--is-' + size]"
      :required="required"
      @change="$emit('change', $event.target.value)"
    >
      <slot
        v-if="options.length"
        name="options"
      >
        <option
          v-for="option in options"
          :key="option"
          :value="option.value"
        >
          {{ option.name }}
        </option>
      </slot>

      <slot v-else></slot>
    </select>
  </div>
</template>

<script>
export default {
  name: 'FormSelect',
  props: {
    id: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String
    },
    required: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: ''
    },
    value: {},
  },
  data () {
    return {
    };
  },
  methods: {
    uniqueId () {
      return 'fid_' + this._uid;
    },

    updateValue (value) {
      this.$emit('input', value);
    }
  }
};
</script>

<style lang="scss" scoped>
/**
 * FormSelect
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Form select field
 * @since 2021-09-01
**/

$component: 'form-select';

.#{$component} {
  display: inline-block;

  &__control {
    width: 100%;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    outline: none;
    @include padding-top(map-get($spacers, 3) / 3);
    @include padding-right(map-get($spacers, 5));
    @include padding-bottom(map-get($spacers, 3) / 3);
    @include padding-left(map-get($spacers, 5) / 3);
    border: 1px solid $sky-dark;
    border-radius: $border-radius;
    // box-shadow: 0px 1px 0px rgba(0, 0, 0, 0.05);
    box-shadow: 0 1px 0 rgba($ink-lighter, 0.20);
    // background-color: $white;
    background: $white url(data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0Ljk1IDEwIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZmZjt9LmNscy0ye2ZpbGw6IzQ0NDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmFycm93czwvdGl0bGU+PHJlY3QgY2xhc3M9ImNscy0xIiB3aWR0aD0iNC45NSIgaGVpZ2h0PSIxMCIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtMiIgcG9pbnRzPSIxLjQxIDQuNjcgMi40OCAzLjE4IDMuNTQgNC42NyAxLjQxIDQuNjciLz48cG9seWdvbiBjbGFzcz0iY2xzLTIiIHBvaW50cz0iMy41NCA1LjMzIDIuNDggNi44MiAxLjQxIDUuMzMgMy41NCA1LjMzIi8+PC9zdmc+) no-repeat 92%;
    color: $ink;
    @include font-size($font-size-base);
    line-height: $line-height-base;

    option {
      font-size: unset;
    }
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
  }
}
</style>
